module.exports = __webpack_public_path__ + "img/staff-admin-icon.b01abe86.svg";